module.exports = __webpack_public_path__ + "img/time-management-1.6eb0408c.svg";